<template>
  <div class="main">
    <banner-swiper class="other">
      <swiper-slide>
        <div class="banner-cover" />
        <div class="banner-desc other">
          <div class="icon" />
          <div class="title">浅阅科技</div>
          <div class="text">年轻与老练并存 活力与沉稳并济</div>
        </div>
      </swiper-slide>
      <div slot="after" class="english-run">SHALRD</div>
    </banner-swiper>
  </div>
</template>

<script>
import BannerSwiper from '@/components/bannerSwiper'

export default {
  name: 'About',
  components: {
    BannerSwiper
  }
}
</script>

<style lang="scss" scoped>
.banner-container{
  .banner-cover{
    background-image: url('../../assets/banner_about.jpg');
  }
}
</style>
